// import store from './../../../store';

import {
  FETCH_ALL_CREDIT_NOTE_PRODUCTS,
  RESET_CREDIT_NOTE_PRODUCTS,
  REMOVE_CREDIT_NOTE_PRODUCT,
  ADD_CREDIT_NOTE_PRODUCT,
  UPDATE_CREDIT_NOTE_PRODUCT,
} from './../../mutation-types';

export default {
  [RESET_CREDIT_NOTE_PRODUCTS](state) {
    state.all = [];
  },

  [FETCH_ALL_CREDIT_NOTE_PRODUCTS](state, creditNoteProducts) {
    state.all = creditNoteProducts;
  },

  [REMOVE_CREDIT_NOTE_PRODUCT](state, id) {
    state.all = state.all.filter(p => p.id !== id);
  },

  [ADD_CREDIT_NOTE_PRODUCT](state, creditNoteProduct) {
    state.all.push(creditNoteProduct);
  },

  [UPDATE_CREDIT_NOTE_PRODUCT](state, { creditNoteProduct, id }) {
    state.all.map((p) => {
      if (p.id.toString() === id.toString()) {
        Object.keys(creditNoteProduct).map((k) => {
          p[k] = creditNoteProduct[k];
          return k;
        });
      }
      return p;
    });
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/creditNoteProduct/mutations.js